'use strict';

window.CFC = window.CFC || {};
window.CFC.NutritionalComparison = (function($) {
  var $nutritionalComparison;
  var $chickenCutSelect;
  var $compareTypeSelect;
  var $compareCutSelect;
  var $results;

  var compareData;
  var chickenCutData;
  
  function init() {
    $nutritionalComparison = $('#nutritionalComparison');

    if (!$nutritionalComparison.length) { return; }

    $chickenCutSelect = $('#nutritionalComparison__chickenCut');
    $compareTypeSelect = $('#nutritionalComparison__compareType');
    $compareCutSelect = $('#nutritionalComparison__compareCut');
    $results = $('#nutritionalComparison__results');
    
    $chickenCutSelect.on('change', updateChickenCutSelect);
    $compareTypeSelect.on('change', updateCompareTypeSelect);
    $compareCutSelect.on('change', updateCompareCutSelect);

    fetch(window.CFC_Vars.themeRoot + '/assets/data/nutritional_comparison_data.js')
      .then(function(response) { return response.json(); })
      .then(initWithData);
  }
  
  function getCutsOfSelectedMeat() {
    var type = $compareTypeSelect.val();
    return compareData[type] || null;
  }
  
  function initWithData(data) {
    var localizedData = data[document.documentElement.lang];

    if (!localizedData) { return; }
    
    compareData = {};
    chickenCutData = {};

    localizedData.forEach(function(item) {
      var type = item.Type;
      var cut = item.Name;
      
      if (type === 'chicken') {
        chickenCutData[cut] = item;
      }
      else {
        compareData[type] = compareData[type] || {};
        compareData[type][cut] = item;
      }
    });

    updateCompareTypeSelect();
    updateChickenCutSelect();
    
    
    $chickenCutSelect[0].styledDropdown.copyOptionsFromSelect();
    $compareTypeSelect[0].styledDropdown.copyOptionsFromSelect();
    $compareCutSelect[0].styledDropdown.copyOptionsFromSelect();
  }
  
  function setOptions($select, optionNames) {
    var current = $select.val();
    if (!optionNames.includes(current)) { current = ''; }

    $select.find("option[value!='']").remove();
    $select[0].selectedIndex = 0;
    
    var $options = optionNames.map(function(typeName) { 
      return $('<option></option>').attr('value', typeName).text(typeName);
    });
    
    $select.append($options);
    $select.val(current);
    $select[0].styledDropdown.copyOptionsFromSelect();
  }
  
  function updateCompareTypeSelect() {
    var types = Object.getOwnPropertyNames(compareData);
    setOptions($compareTypeSelect, types);
    updateCompareCutSelect();
  }
  
  function updateCompareCutSelect() {
    var cuts = getCutsOfSelectedMeat();
    var cutOptions = cuts ? Object.getOwnPropertyNames(cuts) : [];
    setOptions($compareCutSelect, cutOptions);
    updateResults();
  }
  
  function updateChickenCutSelect() {
    var cuts = Object.getOwnPropertyNames(chickenCutData);
    setOptions($chickenCutSelect, cuts);
    updateResults();
  }
  
  function updateResults() {
    var compareType = $compareTypeSelect.val();
    var compareCut = $compareCutSelect.val();
    var chickenCut = $chickenCutSelect.val();
    
    var typeData = compareData[compareType];
    var cutData = typeData && typeData[compareCut];
    var chickenData = chickenCutData[chickenCut];

    if (!cutData || !chickenData) {
      $results.hide();
      return;
    }
    
    $results.find('[data-field=chickenCut]').text(chickenCut);
    $results.find('[data-field=compareCut]').text(compareCut);
    
    Object.getOwnPropertyNames(chickenData).forEach(function(field) {
      var $cells = $results.find('[data-field=' + field + '] td');
      $cells.eq(1).text(chickenData[field]);
      $cells.eq(2).text(cutData[field]);
    });
    
    $results.show();
  }
  
  $(init);
})(jQuery);